<p-accordion [activeIndex]="-1" (onOpen)="loadHistory()">
	<p-accordionTab>
		<p-header>
			<div class="history-header">HISTORY</div>
		</p-header>

		<div class="date-blocks" *ngIf="!historyIsLoading ">
			<div class="date-block" *ngFor="let notificationEntry of (notificationMap$) | keyvalue : returnZero">
				<div class="nfs-block">
					<div *ngFor="let notification of notificationEntry.value; trackBy: trackEntityById">

						<app-history-notification [ngClass]="{'unreaded-nf': !notification.readStatus && !nfsReaded}" [notification]="notification" [history]="true" ></app-history-notification>

					</div>
				</div>
			</div>
		</div>

		<div class="history-loading-screen" *ngIf="historyIsLoading">
			<lib-progress-spinner></lib-progress-spinner>
		</div>
		<div *ngIf="notificationMap$?.size === 0" class="no-history">
			No History
		</div>
	</p-accordionTab>
</p-accordion>